import React, { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import "./Authentication/Register";
import Login from "./Authentication/Login";
import ForgotPassword from "./Authentication/ForgotPassword";
import "./Home/Homepage";
import RenderOrder from "./Home/RenderOrder";
import PublicDashboard from "./Home/PublicDashboard";
import BusinessAssistant from "./MantisBusiness/Sections/Business/BusinessAssistant";
import "./MantisBusiness/Sections/Documents/Archive";
import BusinessExtraction from "./MantisBusiness/Sections/Business/BusinessExtraction";
import "./MantisBusiness/Sections/User/UsersSection";
import BusinessIntegrations from "./MantisBusiness/Sections/Business/BusinessIntegrations";
import BusinessDashboard from "./MantisBusiness/Sections/Business/BusinessDashboard";
import BusinessUsers from "./MantisBusiness/Sections/Business/BusinessUsers";
import BusinessArchive from "./MantisBusiness/Sections/Business/BusinessArchive";
import Notifications from "./MantisBusiness/Sections/User/Notifications";
import {
  userLogin,
  userLogout,
  setUser,
  setIsAdmin,
  setIsMentor,
  setIsSherpa,
  setToken,
  setUserId,
  setIsBusiness,
  setMantisBusiness,
} from "./Redux/modules/auth";
import { connect } from "react-redux";
import sandyLogo from "./Assets/img/sandyIsotype.png";
import { brand } from "./config";
import mantisLogo from "./Assets/img/mantisCircle.png";
import Cookies from "js-cookie";
import { verifyToken, logout } from "./ApiCalls/authentication";
import "./App.scss";
import EmailValidation from "./Extras/EmailValidation";
import "./Navbar/Navbar";
import MantisEmpresasHome from "./Extras/MantisEmpresasHome";
import BusinessLogin from "./Authentication/BusinessLogin";
import BusinessBackoffice from "./MantisBusiness/Sections/Business/BusinessBackoffice";
import BusinessSignup from "./Authentication/BusinessSignup";
import ForgotPasswordBusiness from "./Authentication/ForgotPasswordBusiness";
import DocumentSection from "./MantisBusiness/Sections/Documents/DocumentSection";
import { Helmet } from "react-helmet";
import PreventBackNavigation from "./Authentication/PreventBackNavigation";
import PublicForm from "./MantisBusiness/Sections/Forms/PublicForm";
import ProtectedRoute from "./components/ProtectedRoute";
import DataTreatmentPolicies from "./Extras/DataTreatmentPolicies";
import TermsAndConditions from "./Extras/TermsAndConditions";

function mapDispatchToProps(dispatch) {
  return {
    userLogin: () => dispatch(userLogin()),
    userLogout: () => dispatch(userLogout()),
    setUser: (user) => dispatch(setUser(user)),
    setUserId: (userId) => dispatch(setUserId(userId)),
    setIsAdmin: (isAdmin) => dispatch(setIsAdmin(isAdmin)),
    setIsSherpa: (isSherpa) => dispatch(setIsSherpa(isSherpa)),
    setIsMentor: (isMentor) => dispatch(setIsMentor(isMentor)),
    setToken: (token) => dispatch(setToken(token)),
    setIsBusiness: (isBusiness) => dispatch(setIsBusiness(isBusiness)),
    setMantisBusiness: (mantisBusiness) =>
      dispatch(setMantisBusiness(mantisBusiness)),
  };
}

const select = (state) => {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    isBusiness: state.auth.isBusiness,
    mantisBusiness: state.auth.mantisBusiness,
  };
};

function App(props) {
  const navigate = useNavigate();
  useState(false);
  const [isSessionVerifying, setIsSessionVerifying] = useState(true);
  const location = useLocation();
  const excludedPaths = [
    "/",
    "/login",
    "/businessRegister",
    "/forgotPassword",
    "/forgotPasswordBusiness",
  ];
  const shouldShowNotifications = !excludedPaths.some(
    (path) => location.pathname in excludedPaths
  );

  useEffect(() => {
    function handleSessionExpiration() {
      logout();
      props.userLogout();
      navigate("/");
    }

    // L-01 (MA-06): the JWT lives in an httpOnly cookie now, so there's nothing to
    // read from storage. The non-httpOnly csrfToken cookie (set by the backend at
    // login/verifyToken) is the only readable signal a session might exist — gate on
    // that instead, same as before, just sourced from the cookie instead of the token.
    async function verifySession() {
      console.log('🔐 App: Starting session verification...');

      if (Cookies.get("csrfToken")) {
        console.log('🔐 App: Plausible session found, verifying with server...');
        const json = await verifyToken();
        if (json.success) {
          console.log('🔐 App: Token verification successful, updating state...');
          props.setUser({ user: json.user });
          props.setUserId({ userId: json.userId });
          props.setIsAdmin({ isAdmin: json.isAdmin });
          props.setIsMentor({ isMentor: json.isMentor });
          props.setIsSherpa({ isSherpa: json.isSherpa });
          props.setIsBusiness({ isBusiness: json.isBusiness });
          props.setMantisBusiness({ mantisBusiness: json.mantisBusiness });
          props.userLogin();
        } else {
          console.log('🔐 App: Token verification failed, logging out...');
          handleSessionExpiration();
        }
      } else {
        console.log('🔐 App: No session cookie found');
      }

      // Mark session verification as complete
      console.log('🔐 App: Session verification complete');
      setIsSessionVerifying(false);
    }

    verifySession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>{brand === "MANTIS" ? "Mantis" : "Sandy"}</title>
        <link
          rel="icon"
          type="image/png"
          href={brand === "MANTIS" ? mantisLogo : sandyLogo}
        />
      </Helmet>
      <div className="home-component">
        {shouldShowNotifications && props.authenticated && <Notifications />}
        <PreventBackNavigation
          isAuthenticated={props.authenticated && props.isBusiness}
        />

        <div className="app-content">
          <Routes>
            {/* <Route path="/" exact element={<Homepage />} /> */}
            {/* <Route path="/testBelvoData" exact element={<BelvoTestData />} />
            <Route path="/signup" exact element={<Register />} /> */}
            <Route path="/ipr-status" element={<RenderOrder />} />
            <Route path="/public-dashboard" element={<PublicDashboard />} />
            <Route path="/login" exact element={<Login />} />
            <Route path="/" exact element={<BusinessLogin />} />
            <Route
              path="/businessRegister"
              exact
              element={<BusinessSignup />}
            />
            <Route
              path="/forgotPassword/:token"
              exact
              element={<ForgotPassword />}
            />
            <Route
              path="/forgotPasswordBusiness/:token"
              exact
              element={<ForgotPasswordBusiness />}
            />
            {/* <Route
              path="/widget/yoint/result/:userId"
              exact
              element={<YointResponse />}
            /> */}
            <Route path="/validateEmail" exact element={<EmailValidation />} />

            <Route
              path="/mantisEmpresas"
              exact
              element={<MantisEmpresasHome />}
            />

            <Route
              path="form/:shareId/:submissionId?"
              exact
              element={<PublicForm />}
            />

            <Route
              path="/data-treatment-policies"
              exact
              element={<DataTreatmentPolicies />}
            />

            <Route
              path="/terms-and-conditions"
              exact
              element={<TermsAndConditions />}
            />

            {/* Ruta protegida específica para Control Panel P2O */}
            <Route
              path="/business/backoffice/control-panel-p2o/:iprId?"
              element={
                <ProtectedRoute isSessionVerifying={isSessionVerifying}>
                  <BusinessBackoffice />
                </ProtectedRoute>
              }
            />

            {props.authenticated && props.isBusiness && (
              <>
                <Route
                  path="/business/backoffice"
                  element={<BusinessBackoffice />}
                >
                  <Route index element={<Navigate to="dashboard" replace />} />
                  <Route
                    path="/business/backoffice:activeTab"
                    element={<BusinessBackoffice />}
                  >
                    <Route
                      path="dashboard/:idDashboard?"
                      element={<BusinessDashboard />}
                    />
                    <Route path="assistant" element={<BusinessAssistant />} />
                    <Route path="archive" element={<BusinessArchive />} />
                    <Route
                      path="control-panel/:id?"
                      element={<BusinessExtraction />}
                    />
                    <Route path="users" element={<BusinessUsers />} />
                    <Route
                      path="integrations"
                      element={<BusinessIntegrations />}
                    />
                    <Route path="inbox" element={<DocumentSection />} />
                  </Route>
                </Route>
                <Route
                  path="/business/backoffice/outlets"
                  element={<BusinessBackoffice />}
                />
              </>
            )}
          </Routes>
        </div>
        {/* </BrowserRouter> */}
      </div>
    </>
  );
}

export default connect(select, mapDispatchToProps)(App);
